import { createMultiCart } from './createMultiCart'
import { moveItemsToTargetCart } from './moveItemsToTargetCart'

export type CreateAndMoveItemsToTargetCartResponse = {
  createdCart: App.MultiCartSummary
  cartId: string
  targetCartId: string
  itemIds: Array<string>
  skipNotification: boolean
}

export async function createAndMoveItemsToTargetCart(input: { sourceCartId: string, cartName: string, itemIdsToMove: Array<string>, skipNotification: boolean }): Promise<CreateAndMoveItemsToTargetCartResponse> {
  const createdCart = await createMultiCart(input.cartName, [])
  const targetCartId = createdCart.cartId
  const itemIdsToMove = input.itemIdsToMove

  if (itemIdsToMove.length > 0) {
    await moveItemsToTargetCart({
      sourceCartId: input.sourceCartId,
      targetCartId,
      itemIdsToMove,
    })
  }

  return { createdCart, cartId: input.sourceCartId, targetCartId, itemIds: itemIdsToMove, skipNotification: input.skipNotification }
}
